module.exports = __webpack_public_path__ + "img/mascotLoading.32d83dab.png";